import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import RegisterComponentIcon from '@material-ui/icons/PostAdd';
import MenuIcon from '@material-ui/icons/Menu';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { useMediaQuery, useTheme } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { rootTranslationRef } from '../../translations/features/root/root';
import { SidebarToggleButton } from './SidebarToggleButton';
import { SidebarMenuIcon } from './SidebarMenuIcon';
import { UserMenuDropdown } from './UserMenuDropdown';

export const Root = () => {
  const { t } = useTranslationRef(rootTranslationRef);
  const theme = useTheme();

  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });

  return (
    <Sidebar>
      {!isMobileDevice && (
        <>
          <SidebarGroup label={t('sidebar.group.menu')} icon={<SidebarMenuIcon />}>
            <SidebarToggleButton />
          </SidebarGroup>
          <SidebarDivider />
        </>
      )}

      <SidebarGroup
        label={t('sidebar.group.search') as string}
        icon={<SearchIcon />}
        to="/search"
      >
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />

      <SidebarGroup
        label={t('sidebar.group.navigation')}
        icon={isMobileDevice ? <MenuIcon /> : <SidebarMenuIcon />}
      >
        <SidebarItem
          icon={HomeIcon}
          to="catalog"
          text={t('sidebar.link.home')}
        />
        <SidebarItem
          icon={ExtensionIcon}
          to="api-docs"
          text={t('sidebar.link.apis')}
        />
        <SidebarItem
          icon={LibraryBooks}
          to="docs"
          text={t('sidebar.link.docs')}
        />
        <SidebarItem
          icon={CreateComponentIcon}
          to="create"
          text={t('sidebar.link.create')}
        />
        <SidebarItem
          icon={RegisterComponentIcon}
          to="catalog-import"
          text={t('sidebar.link.register')}
        />
        <SidebarDivider />
      </SidebarGroup>

      <SidebarSpace />

      <SidebarDivider />

      <NotificationsSidebarItem text={t('sidebar.link.notifications')} />

      <SidebarDivider />

      <SidebarGroup
        label={t('sidebar.group.settings')}
        icon={isMobileDevice ? <UserSettingsSignInAvatar /> : undefined}
        to={isMobileDevice ? "/settings" : undefined}
      >
        {isMobileDevice ? (
          <SidebarSettings />
        ) : (
          <UserMenuDropdown />
        )}
      </SidebarGroup>
    </Sidebar>
  );
};
